import { Routes } from '@angular/router';
import { authGuard } from '@core/guard/auth.guard';
import { maintenanceGuard } from '@core/guard/maintenance.guard';
import { AUTH_ROUTES } from '@features/auth/auth.routes';

export const routes: Routes = [
  {
    path: 'maintenance',
    canActivate: [maintenanceGuard],
    data: {
      layout: 'empty',
    },
    loadComponent: () => import('@features/maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
  },
  ...AUTH_ROUTES,
  {
    path: '',
    canActivate: [maintenanceGuard, authGuard],
    canActivateChild: [authGuard],
    data: {
      layout: 'default',
    },
    children: [
      {
        path: 'move',
        loadChildren: () => import('@features/move/move.routes').then((m) => m.MOVE_ROUTES),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('@features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'contracts',
        loadChildren: () => import('@features/contract/contract.routes').then((m) => m.CONTRACT_ROUTES),
      },
      {
        path: 'invoices',
        loadChildren: () => import('@features/invoice/invoice.routes').then((m) => m.INVOICE_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () => import('@features/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
      },
      {
        path: 'contact',
        loadChildren: () => import('@features/contact/contact.routes').then((m) => m.CONTACT_ROUTES),
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
